// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rag_header{
    color: #0066CC;
    font-weight: 600;
    font-size: 1rem;
}

.rag_subheader{
    color: #838FB4;
    font-weight: 400;
    font-size: .875rem;
}

.css-y2ff7i-MuiPaper-root-MuiTableContainer-root.ragTable_container {
    overflow-y: auto;
    height: calc(100vh - 15rem);
}

.ragTable_container::-webkit-scrollbar {
    width: 5px;
    height: 8px;
}

.ragTable_container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}
  
.ragTable_container::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
}

.ragTable_container .muted-head {
    color: #303030 !important;
    font-weight: 400;
    /* font-family: "Unilever Desire"; */
}

.ragTable_container thead{
    height: 2.6875rem;
}

.table_row{
    background: #EBF2FE;
}

/* .ragTable_container .css-1xtozoh-MuiTableRow-root { */
.ragTable_container .row-main, .ragTable_container .child-row {
    height: 3.75rem;
    color: #111111;
    /* font-family: "Unilever Desire"; */
}
.ragTable_container .css-jiabcu-MuiTableCell-root{
    color: #111111;
    /* font-family: "Unilever Desire"; */
    font-size: .8125rem;
}

.status-chip.completed {
    background: rgba(0, 134, 81, 0.15);
    color: #008651;
    border-color: #008651;
    font-weight: 400;
    width: 91px;
    /* font-size: .875rem; */
    /* font-family: "Unilever Desire"; */
}

.status-chip.inprogress {
    background-color: rgba(255, 158, 0, 0.15);
    color: #FF9E00;
    border-color: #FF9E00;
    font-weight: 400;
    font-size: .875rem;
    width: 91px;
    /* font-family: "Unilever Desire"; */
}

.status-chip.failed {
    background-color: #FED7D7;
    color: #C53030;
    border-color: #C53030;
    font-weight: 400;
    font-size: .875rem;
    width: 90px;
    /* font-family: "Unilever Desire"; */
}

/* MUI Chip root inherits our classes */
.status-chip.completed .MuiChip-label,
.status-chip.inprogress .MuiChip-label {
    padding-left: 10px;
    padding-right: 10px;
}

.ragTable_container .table thead th {
    background-color: #EBF2FE;
}

.ragTable_container .form-switch input{
    width: 34px;
    height: 20px;
}

.table-footer {
    background: #eef3ff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    /* padding: 12px 16px; */
    padding: 8px 16px;
    height: 3.5rem;
}

.page-size-select .MuiSelect-select {
    padding-top: 6px;
    padding-bottom: 6px;
}

/* Light shadow like the screenshot */
.MuiPaper-root {
    border-radius: 8px !important;
    border: 1px solid #e5e7eb;
}

.arrow-btn {
    color: #6b7280;
    padding: 2px;
    margin-right: 6px;
    transition: transform 0.18s ease, color 0.18s ease;
}

.arrow-btn.open {
    transform: rotate(90deg);
    color: #0d6efd;
    /* bootstrap primary */
}

.arrow-spacer {
    display: inline-block;
    width: 28px;
}

.expand-panel {
    background: #f6f8ff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 12px;
    margin: 8px 0;
}

.expand-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.expand-grid .label {
    font-size: 12px;
    color: #6b7280;
}

.expand-grid .value {
    font-size: 14px;
    font-weight: 500;
}

@media (max-width: 768px) {
    .expand-grid {
        grid-template-columns: 1fr;
    }
}

/* Expanded row background across all cells */
.row-main.open .MuiTableCell-root {
    /* background-color: rgba(191, 215, 251, 1); */
    background-color: #EBF2FE;
    /* highlighted parent row */
}

.child-row .first-cell {
    /* padding-left: 4px; */
    padding-left: 16px;
}

.child-row .MuiTableCell-root {
    background-color: rgba(0, 71, 179, 0.04);
    /* keep children white like screenshot */
}

/* Optional: subtle transition for cells */
.row-main .MuiTableCell-root {
    transition: background-color 0.18s ease;
}`, "",{"version":3,"sources":["webpack://./src/Pages/RagBuilder/RagBuilder.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yCAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;IACI,eAAe;IACf,cAAc;IACd,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;IACzC,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,oCAAoC;AACxC;;AAEA,uCAAuC;AACvC;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,6CAA6C;AAC7C;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,wCAAwC;AAC5C;;AAEA,0CAA0C;AAC1C;IACI,uCAAuC;AAC3C","sourcesContent":[".rag_header{\n    color: #0066CC;\n    font-weight: 600;\n    font-size: 1rem;\n}\n\n.rag_subheader{\n    color: #838FB4;\n    font-weight: 400;\n    font-size: .875rem;\n}\n\n.css-y2ff7i-MuiPaper-root-MuiTableContainer-root.ragTable_container {\n    overflow-y: auto;\n    height: calc(100vh - 15rem);\n}\n\n.ragTable_container::-webkit-scrollbar {\n    width: 5px;\n    height: 8px;\n}\n\n.ragTable_container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n  \n.ragTable_container::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 4px;\n    transition: background-color 0.3s;\n}\n\n.ragTable_container .muted-head {\n    color: #303030 !important;\n    font-weight: 400;\n    /* font-family: \"Unilever Desire\"; */\n}\n\n.ragTable_container thead{\n    height: 2.6875rem;\n}\n\n.table_row{\n    background: #EBF2FE;\n}\n\n/* .ragTable_container .css-1xtozoh-MuiTableRow-root { */\n.ragTable_container .row-main, .ragTable_container .child-row {\n    height: 3.75rem;\n    color: #111111;\n    /* font-family: \"Unilever Desire\"; */\n}\n.ragTable_container .css-jiabcu-MuiTableCell-root{\n    color: #111111;\n    /* font-family: \"Unilever Desire\"; */\n    font-size: .8125rem;\n}\n\n.status-chip.completed {\n    background: rgba(0, 134, 81, 0.15);\n    color: #008651;\n    border-color: #008651;\n    font-weight: 400;\n    width: 91px;\n    /* font-size: .875rem; */\n    /* font-family: \"Unilever Desire\"; */\n}\n\n.status-chip.inprogress {\n    background-color: rgba(255, 158, 0, 0.15);\n    color: #FF9E00;\n    border-color: #FF9E00;\n    font-weight: 400;\n    font-size: .875rem;\n    width: 91px;\n    /* font-family: \"Unilever Desire\"; */\n}\n\n.status-chip.failed {\n    background-color: #FED7D7;\n    color: #C53030;\n    border-color: #C53030;\n    font-weight: 400;\n    font-size: .875rem;\n    width: 90px;\n    /* font-family: \"Unilever Desire\"; */\n}\n\n/* MUI Chip root inherits our classes */\n.status-chip.completed .MuiChip-label,\n.status-chip.inprogress .MuiChip-label {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.ragTable_container .table thead th {\n    background-color: #EBF2FE;\n}\n\n.ragTable_container .form-switch input{\n    width: 34px;\n    height: 20px;\n}\n\n.table-footer {\n    background: #eef3ff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    /* padding: 12px 16px; */\n    padding: 8px 16px;\n    height: 3.5rem;\n}\n\n.page-size-select .MuiSelect-select {\n    padding-top: 6px;\n    padding-bottom: 6px;\n}\n\n/* Light shadow like the screenshot */\n.MuiPaper-root {\n    border-radius: 8px !important;\n    border: 1px solid #e5e7eb;\n}\n\n.arrow-btn {\n    color: #6b7280;\n    padding: 2px;\n    margin-right: 6px;\n    transition: transform 0.18s ease, color 0.18s ease;\n}\n\n.arrow-btn.open {\n    transform: rotate(90deg);\n    color: #0d6efd;\n    /* bootstrap primary */\n}\n\n.arrow-spacer {\n    display: inline-block;\n    width: 28px;\n}\n\n.expand-panel {\n    background: #f6f8ff;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    padding: 12px;\n    margin: 8px 0;\n}\n\n.expand-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 12px;\n}\n\n.expand-grid .label {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n.expand-grid .value {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n@media (max-width: 768px) {\n    .expand-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Expanded row background across all cells */\n.row-main.open .MuiTableCell-root {\n    /* background-color: rgba(191, 215, 251, 1); */\n    background-color: #EBF2FE;\n    /* highlighted parent row */\n}\n\n.child-row .first-cell {\n    /* padding-left: 4px; */\n    padding-left: 16px;\n}\n\n.child-row .MuiTableCell-root {\n    background-color: rgba(0, 71, 179, 0.04);\n    /* keep children white like screenshot */\n}\n\n/* Optional: subtle transition for cells */\n.row-main .MuiTableCell-root {\n    transition: background-color 0.18s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
